<template>
  <section id="landing__banner-slideshow" class="banner-slideshow">
    <carousel
      :autoplay="true"
      :per-page="1"
      :paginationEnabled="false"
      :autoplayTimeout="5000"
      :loop="true"
      v-scroll-reveal
    >
      <slide v-for="banner in banners" :key="banner.imgSrc">
        <img :src="banner.imgSrc" />
      </slide>
    </carousel>
  </section>
</template>

<script>
export default {
  data() {
    return {
      banners: [
        {
          imgSrc: "https://arctec.ie/assets/banners/banner1.png"
        },
        {
          imgSrc: "https://arctec.ie/assets/banners/banner2.png"
        },
        {
          imgSrc: "https://arctec.ie/assets/banners/banner3.png"
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.banner-slideshow {
  width: 100%;

  img {
    width: 100%;
    object-fit: cover;
  }
}
</style>